// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"checkboxContainer__h49Vf","checkmark":"checkmark__wpzmX"};